import React, { useState, useEffect } from 'react';
import { IoClose } from 'react-icons/io5';

const CentumthPromo = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const hasSeenPromo = localStorage.getItem('seen-centumth-promo');
        if (!hasSeenPromo) {
            // Show after a small delay
            const timer = setTimeout(() => setIsVisible(true), 2000);
            return () => clearTimeout(timer);
        }
    }, []);

    const handleClose = () => {
        setIsVisible(false);
        localStorage.setItem('seen-centumth-promo', 'true');
    };

    if (!isVisible) return null;

    return (
        <div className="fixed top-20 right-4 z-50 animate-slide-up w-[90%] max-w-sm sm:w-auto">
            <div className="bg-white dark:bg-gray-800 rounded-xl shadow-2xl border border-gray-200 dark:border-gray-700 p-4 flex items-start relative overflow-hidden">
                {/* Close Button */}
                <button 
                    onClick={handleClose}
                    className="absolute top-2 right-2 text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 p-1"
                    aria-label="Close promotion"
                >
                    <IoClose size={18} />
                </button>

                {/* Logo */}
                <a href="https://centumth.com" target="_blank" rel="noopener noreferrer" className="flex-shrink-0 mr-4 mt-1">
                    <img 
                        src="/Centumth_favicon.png" 
                        alt="Centumth Logo" 
                        className="w-14 h-14 rounded-lg object-cover shadow-sm hover:opacity-90 transition-opacity" 
                    />
                </a>

                {/* Content */}
                <div className="flex-1 pr-5">
                    <h3 className="font-bold text-sm text-foreground dark:text-dark-foreground mb-1">
                        Check Out My New Daily Game!
                    </h3>
                    <p className="text-xs text-gray-600 dark:text-gray-400 mb-2 leading-relaxed">
                        Guess the items ranked closest to #100 in today's category. Aim for the highest score!
                    </p>
                    <a 
                        href="https://centumth.com" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="inline-flex items-center text-xs font-bold text-white dark:text-black bg-black dark:bg-white hover:opacity-90 px-3 py-1.5 rounded-md"
                    >
                        Play Centumth →
                    </a>
                </div>
            </div>
        </div>
    );
};

export default CentumthPromo;

